import { render, staticRenderFns } from "./greyHeader.vue?vue&type=template&id=70aded79&scoped=true&"
import script from "./greyHeader.vue?vue&type=script&lang=js&"
export * from "./greyHeader.vue?vue&type=script&lang=js&"
import style0 from "./greyHeader.vue?vue&type=style&index=0&id=70aded79&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70aded79",
  null
  
)

export default component.exports